export const VendorsPermissions = {
  ViewVendors: {
    permissionsId: "19508e3f-a414-4b64-b6e6-08dd8b9e8c29",
    permissionsName: "View Vendors",
    description: null,
    componentsId: null,
    components: null,
  },
  EditOfferInVendorProfile: {
    permissionsId: "92539f8d-badc-4c48-82fc-73e5aa4978d2",
    permissionsName: "Edit Offer in Vendor Profile",
    description: null,
    componentsId: null,
    components: null,
  },
  CreateOfferInVendorProfile: {
    permissionsId: "cc13699e-4b23-42eb-9e2f-aaed9bf13b16",
    permissionsName: "Create Offer in Vendor Profile",
    description: null,
    componentsId: null,
    components: null,
  },
};
